import { SaveButton } from "components/Buttons"
import { IMAGES } from "constants/index"
import React, { useEffect, useRef, useState } from "react"
import PerfectScrollbar from "react-perfect-scrollbar"
import "react-perfect-scrollbar/dist/css/styles.css"
import { connect } from "react-redux"
import { Button, Col, Row, Spinner, UncontrolledTooltip } from "reactstrap"
import { getMessageAttachment, sendTextMessage } from "services/quickblox"
import {
  deleteChatMessages,
  loadChatMessages,
  sendChatNotification,
  sendMessageWithMedia,
} from "store/actions"
import {
  getFileBytes,
  getFormattedTime,
  returnMediaType,
  usePrevious,
} from "utils"

const ChatBox = ({
  messages,
  loadChatMessages,
  QBDialog,
  currentUser,
  chatUsers,
  chatCredentials,
  deleteChatMessages,
  QBSession,
  sendChatNotification,
  selectedEvent,
  commentBoard,
  vendorId,
  fromEvent,
  sendMessageWithMedia,
  isSendingMessage,
}) => {
  const [chatBox, setChatBox] = useState()
  const [isSelectActive, setIsSelectActive] = useState(false)
  const [selectedMessages, setSelectedMessages] = useState([])
  const attachmentRef = useRef(null)
  const prevMessages = usePrevious(messages)
  const [currentMessage, setCurrentMessage] = useState("")
  const [uploadedFile, setUploadedFile] = useState(null)

  useEffect(() => {
    if (chatBox) {
      const messageList = messages?.items
      const prevMessageList = prevMessages?.items
      if (
        messageList?.length &&
        prevMessageList?.length &&
        messageList[messageList.length - 1]._id !==
          prevMessageList[prevMessageList.length - 1]._id
      ) {
        chatBox.scrollTop = chatBox.scrollHeight
      }
    }
  }, [messages])

  const loadMessageHandler = () => {
    if (messages?.items?.length === 0) {
      loadChatMessages({
        dialog: QBDialog,
        beforeDateSent: null,
      })
    } else {
      loadChatMessages({
        dialog: QBDialog,
        beforeDateSent: messages.items[0].date_sent,
      })
    }
  }

  const getUserByQBId = userQBId => {
    if (currentUser?.chat_credentials?.qb_id == userQBId) {
      return currentUser
    }
    for (const [, value] of Object.entries(chatUsers)) {
      if (
        value.hasOwnProperty("chat_credentials") &&
        value["chat_credentials"]?.hasOwnProperty("qb_id")
      )
        if (value["chat_credentials"]["qb_id"] === userQBId) {
          return value
        }
    }
    return null
  }

  const handleFileUpload = async event => {
    const files = event.target.files
    if (files.length) {
      const file = files[0]
      const MAX_SIZE = 50 * 1024 * 1024 // 50 MB max file size
      if (returnMediaType(file?.type) === false) {
        alert(`File ${file?.name} has an invalid format.`)
        attachmentRef.current.value = null
      } else {
        if (file?.size > MAX_SIZE) {
          alert(`File ${file?.name} is too big. The maximum limit is 50 MB.`)
          attachmentRef.current.value = null
        } else {
          const attachmentType = file.type.split("/")[0]
          const attachment = await getFileBytes(file)
          setUploadedFile({
            file: file,
            media: attachment,
            type: attachmentType,
          })
        }
      }
    }
  }

  const sendMessage = () => {
    if (!!uploadedFile) {
      sendMessageWithMedia({
        file: uploadedFile?.file,
        mediaType: uploadedFile?.type,
        media: uploadedFile?.media,
        message: currentMessage,
        userId: currentUser.id,
        event_id: fromEvent ? selectedEvent?.id : null,
        menu_item_id: commentBoard?.menu_item_id,
        vendor_id: vendorId,
        xmpp_room_jid: QBDialog.xmpp_room_jid,
      })
      setUploadedFile(null)
      attachmentRef.current.value = null
      setCurrentMessage("")
    } else if (currentMessage?.trim()?.length) {
      sendTextMessage(QBDialog.xmpp_room_jid, currentMessage)
      sendChatNotification({
        sender_id: currentUser.id,
        event_id: fromEvent ? selectedEvent?.id : null,
        vendor_id: vendorId,
        menu_item_id: commentBoard?.menu_item_id,
      })
      setCurrentMessage("")
    }
  }

  const pattern =
    /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi

  return (
    <React.Fragment>
      <Row style={{ margin: "0px" }} className="justify-content-end mt-2">
        <Col xs={12} sm={6} md={3} xl={2}>
          <SaveButton
            type="button"
            fullWidth={true}
            content={isSelectActive ? "Cancel" : "Select"}
            onClick={() => {
              setIsSelectActive(!isSelectActive)
              setSelectedMessages([])
            }}
          />
        </Col>
        <Col xs={12} sm={6} md={3} xl={2}>
          <SaveButton
            type="button"
            fullWidth={true}
            content="Delete"
            disabled={selectedMessages.length === 0}
            onClick={() => {
              deleteChatMessages({
                vendor_id: vendorId,
                message_ids: selectedMessages,
              })
              setSelectedMessages([])
              setIsSelectActive(false)
            }}
          />
        </Col>
      </Row>
      <div>
        <div className="chat-conversation p-3">
          <ul className="list-unstyled mb-0">
            <PerfectScrollbar
              style={{
                height: "486px",
                minHeight: "486px",
                paddingRight: "15px",
              }}
              containerRef={ref => setChatBox(ref)}
            >
              {messages && messages?.showLoadMore && (
                <p
                  style={{ textAlign: "center", cursor: "pointer" }}
                  onClick={loadMessageHandler}
                >
                  <i>Load more messages</i>
                </p>
              )}
              {messages &&
                messages?.items?.map(message => {
                  const currentUser = getUserByQBId(message.sender_id)
                  const currentUserIsSender =
                    message.sender_id === chatCredentials.qb_id
                  const avatarStyle = {
                    float: currentUserIsSender ? "right" : "left",
                    marginLeft: currentUserIsSender ? "10px" : "0px",
                    marginRight: currentUserIsSender ? "0px" : "10px",
                  }
                  const messageHasAttachment =
                    message.hasOwnProperty("attachments") &&
                    message?.attachments?.length > 0
                  return (
                    <li
                      key={message._id}
                      className={currentUserIsSender ? "right" : ""}
                    >
                      {isSelectActive && (
                        <input
                          style={{
                            float: currentUserIsSender ? "right" : "left",
                          }}
                          type="checkbox"
                          checked={selectedMessages.includes(message._id)}
                          onChange={event => {
                            event.target.checked
                              ? setSelectedMessages([
                                  ...selectedMessages,
                                  message._id,
                                ])
                              : setSelectedMessages(
                                  selectedMessages.filter(
                                    item => item !== message._id
                                  )
                                )
                          }}
                        />
                      )}
                      <div
                        className="conversation-list"
                        style={{ marginLeft: "10px" }}
                      >
                        {!currentUser ? (
                          <img
                            src={IMAGES.PROFILE_PLACEHOLDER}
                            className="rounded-circle avatar-xs"
                            style={avatarStyle}
                          />
                        ) : !!currentUser?.profile_pic?.file?.url ? (
                          <img
                            src={currentUser?.profile_pic?.file?.url}
                            className="rounded-circle avatar-xs"
                            style={avatarStyle}
                          />
                        ) : (
                          <div className="avatar-xs" style={avatarStyle}>
                            <span className="avatar-title rounded-circle bg-success text-white font-size-16">
                              {currentUser?.first_name?.charAt(0) || ""}
                              {currentUser?.last_name?.charAt(0) || ""}
                            </span>
                          </div>
                        )}
                        <div className="ctext-wrap">
                          <div className="conversation-name">
                            {currentUser?.display_name || ""}
                          </div>
                          {messageHasAttachment &&
                            (message.attachments[0]?.type === "image" ||
                              message.attachments[0]?.type === "photo") && (
                              <img
                                src={getMessageAttachment(
                                  message?.attachments[0]?.id,
                                  QBSession?.token
                                )}
                                style={{ maxWidth: "20%" }}
                              />
                            )}
                          {messageHasAttachment &&
                            message.attachments[0]?.type === "video" && (
                              <video style={{ maxWidth: "25%" }} controls>
                                <source
                                  src={getMessageAttachment(
                                    message.attachments[0].id,
                                    QBSession.token
                                  )}
                                />
                              </video>
                            )}
                          <p
                            dangerouslySetInnerHTML={{
                              __html: message?.message?.replace(
                                pattern,
                                "<a href='$1' target='_blank'> $1 </a>"
                              ),
                            }}
                          ></p>
                          <p className="chat-time mb-0">
                            <i className="bx bx-time-five align-middle me-1" />
                            {getFormattedTime(message.date_sent * 1000)}
                          </p>
                        </div>
                      </div>
                    </li>
                  )
                })}
            </PerfectScrollbar>
          </ul>
        </div>
        <div className="p-3 chat-input-section">
          {!!uploadedFile && (
            <Row className="mb-3">
              <Col
                xs="auto"
                style={{
                  position: "relative",
                }}
              >
                {uploadedFile?.type === "image" && (
                  <img
                    className="avatar-lg"
                    src={uploadedFile?.media}
                    style={{ blockSize: "auto" }}
                  />
                )}
                {uploadedFile?.type === "video" && (
                  <video
                    className="avatar-lg"
                    src={uploadedFile?.media}
                    style={{ blockSize: "auto" }}
                    controls
                  />
                )}
                <i
                  className="bx bx-x"
                  style={{
                    position: "absolute",
                    top: "5%",
                    right: "12%",
                    cursor: "pointer",
                    fontSize: "18px",
                    borderRadius: "15px",
                    backgroundColor: "white",
                    color: "black",
                  }}
                  onClick={() => {
                    setUploadedFile(null)
                    attachmentRef.current.value = null
                  }}
                />
              </Col>
            </Row>
          )}
          <Row>
            <Col>
              <div className="position-relative">
                <input
                  type="text"
                  value={currentMessage}
                  onChange={e => {
                    setCurrentMessage(e.target.value)
                  }}
                  className="form-control chat-input"
                  placeholder="Enter Message..."
                  onKeyDown={e => {
                    if (e.key === "Enter") {
                      sendMessage()
                    }
                  }}
                />
                <div className="chat-input-links">
                  <ul className="list-inline mb-0">
                    <li className="list-inline-item">
                      <i
                        className="mdi mdi-file-image-outline font-size-20"
                        id="attachmentTooltip"
                        style={{ cursor: "pointer", color: "blue" }}
                        onClick={() => {
                          attachmentRef.current.click()
                        }}
                      ></i>
                      <UncontrolledTooltip
                        placement="top"
                        target="attachmentTooltip"
                      >
                        Attachments
                      </UncontrolledTooltip>
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
            <Col className="col-auto">
              <Button
                type="button"
                color="primary"
                onClick={sendMessage}
                className="btn-rounded chat-send w-md"
                disabled={isSendingMessage}
              >
                {isSendingMessage && <Spinner size={"sm"} color="light" />}
                <span className="d-none d-sm-inline-block me-2 ms-1">Send</span>
                <i className="mdi mdi-send"></i>
              </Button>
            </Col>
          </Row>
        </div>
      </div>
      <input
        ref={attachmentRef}
        type="file"
        accept="image/jpg,image/jpeg,image/png,image/gif,jpg,jpeg,png,gif,mp4,video/mp4"
        className="d-none"
        onChange={handleFileUpload}
      />
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  vendorId: state.Login.vendorId,
  commentBoard: state.CommentBoard.commentBoard,
  currentUser: state.Login.authUser,
  chatUsers: state.CommentBoard.chatUsers,
  chatCredentials: state.Login.authUser.chat_credentials,
  messages: state.CommentBoard.commentBoardMessages,
  QBSession: state.CommentBoard.QBSession,
  QBDialog: state.CommentBoard.QBDialog,
  selectedEvent: state.experiences.selectedEvent,
  isSendingMessage: state.CommentBoard.isSendingMessage,
})

const mapDispatchToProps = dispatch => ({
  loadChatMessages: values => dispatch(loadChatMessages(values)),
  deleteChatMessages: values => dispatch(deleteChatMessages(values)),
  sendChatNotification: values => dispatch(sendChatNotification(values)),
  sendMessageWithMedia: values =>
    dispatch(
      sendMessageWithMedia(
        values?.file,
        values?.mediaType,
        values?.media,
        values?.message,
        values?.userId,
        values?.event_id,
        values?.menu_item_id,
        values?.vendor_id,
        values?.xmpp_room_jid
      )
    ),
})

export default connect(mapStateToProps, mapDispatchToProps)(ChatBox)
